const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
import styled from 'astroturf/react'
import { connect } from 'react-redux'

import { isEmbeddedSelector, isInlineEmbedSelector } from 'selectors/embed'
import _Layout from "Layout.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/layout/index.js?styleId=Layout";



const Layout = /*#__PURE__*/styled('div', null, {
  displayName: "Layout",
  styles: _Layout
})

const mapStateToProps = (state) => ({
  isNotEmbedded: !isEmbeddedSelector(state),
  isNotInlineEmbed: !isInlineEmbedSelector(state)
})

export default connect(mapStateToProps, {})(Layout)
